import { useLang } from '@/app/utils/useLang';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';
import BlackButton from '../BlackButton';
import GiftBoxIcon from './icons/GiftBoxIcon';
import gtm from '@/utils/gtm';

interface RewardItem {
    icon: string;
    title: string;
    desc: string;
}

interface MysteryBoxCard {
    tag: string;
    rewards: RewardItem[];
}

interface RewardCardsProps {
    onJoinNow: () => void;
    onMyMysteryBox: () => void;
    isLoggedIn: boolean;
    campaignId?: string | number;
}

const RewardCards: React.FC<RewardCardsProps> = ({ onJoinNow, onMyMysteryBox, isLoggedIn, campaignId }) => {
    const { t } = useLang('RewardCards');
    const { locale = 'us' } = useRouter();

    function handleJoinNow() {
        onJoinNow();
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('join_now'),

            __btn_id1: 'service-renewal-reward-cards-join-now',
            __btn_id2: 'service-renewal-reward-cards-join-now',
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    }

    function handleMyMysteryBox() {
        onMyMysteryBox();
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('my_mystery_box'),
        });
    }

    // 卡片顺序：Value Reward → Premium Trade-In → Loyalty Thank-You（与设计稿保持一致）
    const cards: MysteryBoxCard[] = [
        {
            tag: t('box2_tag'),
            rewards: [
                {
                    icon: 'https://websiteoss.ecoflow.com/figma-uploads/1775114597725-m224ek-compressed-%E4%BC%98%E6%83%A0%E5%88%B8%201.png',
                    title: t('box2_item1_title'),
                    desc: t('box2_item1_desc'),
                },
            ],
        },
        {
            tag: t('box1_tag'),
            rewards: [
                {
                    icon: 'https://websiteoss.ecoflow.com/figma-uploads/1775114597725-m224ek-compressed-%E4%BC%98%E6%83%A0%E5%88%B8%201.png',
                    title: t('box1_item1_title'),
                    desc: t('box1_item1_desc'),
                },
                {
                    icon: 'https://websiteoss.ecoflow.com/figma-uploads/1775114605759-vuis31-compressed-%E7%A5%A8%E5%88%B8%201.png',
                    title: t('box1_item2_title'),
                    desc: t('box1_item2_desc'),
                },
                {
                    icon: 'https://websiteoss.ecoflow.com/figma-uploads/1775114613717-8cv28v-compressed-%E5%85%85%E7%94%B5%E5%AE%9D%EF%BC%9B%E7%A7%BB%E5%8A%A8%E7%94%B5%E6%BA%90%201.png',
                    title: t('box1_item3_title'),
                    desc: t('box1_item3_desc'),
                },
            ],
        },
        {
            tag: t('box3_tag'),
            rewards: [
                {
                    icon: 'https://websiteoss.ecoflow.com/figma-uploads/1775114597725-m224ek-compressed-%E4%BC%98%E6%83%A0%E5%88%B8%201.png',
                    title: t('box3_item1_title'),
                    desc: t('box3_item1_desc'),
                },
            ],
        },
    ];

    return (
        <div className={`${styles.RewardCards} GtmModuleData-section sr-layout`} data-section-id="service-renewal-reward-cards" id="reward-cards">
            <h2 className="section-title">{t('title')}</h2>
            <div className="btns">
                <BlackButton
                    className="GtmModuleData-btn-common service-renewal-reward-cards-join-now"
                    data-btn-id="service-renewal-reward-cards-join-now"
                    type="primary"
                    shape="round"
                    onClick={handleJoinNow}
                    disabled={!campaignId}
                >
                    {t('join_now')}
                </BlackButton>
                {isLoggedIn && (
                    <BlackButton
                        className="GtmModuleData-btn-common service-renewal-reward-cards-my-mystery-box"
                        data-btn-id="service-renewal-reward-cards-my-mystery-box"
                        type="default"
                        shape="round"
                        onClick={handleMyMysteryBox}
                        disabled={!campaignId}
                    >
                        {t('my_mystery_box')}
                    </BlackButton>
                )}
            </div>
            <ul className="cards-list">
                {cards.map((card, index) => (
                    <li className={`card-item ${card.rewards.length === 1 ? 'card-item--single' : 'card-item--multi'}`} key={index}>
                        <div className="card-label">
                            <GiftBoxIcon />
                            <span>{card.tag}</span>
                        </div>
                        <div className="card-body">
                            <ul className="reward-list">
                                {card.rewards.map((reward, rIndex) => (
                                    <li className="reward-item" key={rIndex}>
                                        <div className="reward-icon">
                                            <EFPicture src={reward.icon} alt={reward.title} />
                                        </div>
                                        <div className="reward-text">
                                            <div className="reward-title">{reward.title}</div>
                                            <div className="reward-desc">{reward.desc}</div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default RewardCards;
